import React, { useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    minWidth: '1000px', 
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const useStyles = makeStyles((_theme) => ({
  select: {
    '&:focus': {
      backgroundColor: 'transparent', 
    },
    '&:hover': {
      backgroundColor: 'transparent', 
    },
    '& .MuiOutlinedInput-notchedOutline': {
    },
  },
}));

const PL3Filters = ({ open,handleApply,handlePL3Close }) => {
  // const classes = useStyles();

  const handleClose = () => {
    handlePL3Close();
  };

  const handleApplyButton = () => {
    handleApply(checkedItems);
  };
  
  const initialItems = [
    { id: 1, label: 'USBB5 - US CREAMERS - SHELF STABLE' },
    { id: 2, label: 'USHHC - US IBD BAKING' },
    { id: 3, label: 'USLL3 - US STANDARD FOOD' },
    { id: 4, label: 'USSBB2 - US MILK MODIFIER' },
    { id: 5, label: 'USBB5 - US CREAMERS - SHELF STABLE' },
    { id: 6, label: 'USHHC - US IBD BAKING' },
    { id: 7, label: 'USLL3 - US STANDARD FOOD' },
    { id: 8, label: 'USSBB2 - US MILK MODIFIER' },
    { id: 9, label: 'USBB5 - US CREAMERS - SHELF STABLE' },
    { id: 10, label: 'USHHC - US IBD BAKING' },
    { id: 11, label: 'USLL3 - US STANDARD FOOD' },
    { id: 12, label: 'USSBB2 - US MILK MODIFIER' },
    { id: 13, label: 'USBB5 - US CREAMERS - SHELF STABLE' },
    { id: 14, label: 'USHHC - US IBD BAKING' },
    { id: 15, label: 'USLL3 - US STANDARD FOOD' },
  ];

  const [checkedItems, setCheckedItems] = useState([]);

  const handleCheckboxChange = (id, label) => {
    const currentIndex = checkedItems.findIndex(item => item.id === id);
    const newChecked = [...checkedItems];

    if (currentIndex === -1) {
      newChecked.push({ id, label });
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setCheckedItems(newChecked);
  };
  const numColumns = Math.ceil(initialItems.length / 5);

  return (
    <BootstrapDialog
      onClose={() => handleClose()}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2, fontSize: 16, fontWeight: 600 }} id="customized-dialog-title">
        Select PL3s
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleClose()}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ display: 'flex' }}>
        {Array.from({ length: numColumns }).map((_, columnIndex) => (
          <Box key={columnIndex} sx={{ width: '50%', paddingRight: '16px' }}>
            {initialItems.slice(columnIndex * 5, columnIndex * 5 + 5).map((item) => (
              <Box key={item.id} sx={{ marginBottom: '8px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedItems.some(checkedItem => checkedItem.id === item.id)}
                      onChange={() => handleCheckboxChange(item.id, item.label)}
                      sx={{
                        color: '#FF8200',
                        '&.Mui-checked': {
                          color: '#FF8200',
                        },
                      }}
                    />
                  }
                  label={<Typography style={{ fontSize: '13px' }}>{item.label}</Typography>}
                />
              </Box>
            ))}
          </Box>
        ))}
      </DialogContent>
      <DialogActions sx={{ mr: 2, p: 4 }}>
        <Button variant='contained' onClick={() => handleClose()} style={{ background: "#FFF", color: "black" }}>
          Cancel
        </Button>
        <Button variant='contained' onClick={() => handleApplyButton()} style={{ background: "#054E9C", color: "#FFF" }}>
          Apply
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default PL3Filters;
